import API from '../../constants/api';
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';
import { setPhotosProducts } from '../reducers/productsReducer';
import errorChecker from './errorChecker';

export const getFoto = () => dispatch =>
  fetch(API.mainAPI + API.fotoPath)
    .then(errorChecker)
    .then(data => dispatch(setPhotosProducts(data)))
    .catch(err => console.log(err));

export const getCalculatedPrice = (id, leather_cover, shilda_text, length) =>
  fetch(`${API.mainAPI}/api/product-options/${id}/calculate-price/`, {
    method: 'post',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({ leather_cover, shilda_text, length }),
  })
    .then(errorChecker)
    .then(data => data)
    .catch(err => console.log(err));
